import {createReducer, on} from '@ngrx/store';
import {Configuration} from '../../shared/models/configuration';

import * as AppActions from './app.actions';
import {AppState} from './app.state';
import {Theme} from "../../shared/models/theme";
import { Icon } from 'src/app/shared/models/icon';
import { sanitizeIcons } from '../../shared/helpers/sanitize-svg';

export const appFeatureKey = 'app';

export const initialState: AppState = {
  isInitializing: true,
  configuration: null,
  theme: null,
  icons: []
};

export const appReducer = createReducer(
  initialState,
  on(AppActions.initializationStarted, (state) => ({ ...state, isInitializing: true })),
  on(AppActions.initializationCompleted, (state) => ({ ...state, isInitializing: false})),
  on(AppActions.setConfiguration, (state, action) => ({ ...state, configuration: { Settings: action.Settings } })),
  on(AppActions.setTheme, (state, action) => ({ ...state, theme: action.theme })),
  on(AppActions.setIcons, (state, action) => ({ ...state, icons: sanitizeIcons(action.icons) }))
);

export const selectIsInitializing = (state: AppState): boolean => state.isInitializing;
export const selectConfiguration = (state: AppState): Configuration => state.configuration;
export const selectTheme = (state: AppState): Theme => state.theme;
export const selectIcons = (state: AppState): Icon[] => state.icons;